/*
  Asistente de cuatro preguntas (sections/asistente.liquid).

  Las respuestas se traducen a los filtros de la tienda y los resultados se
  piden a la coleccion elegida con la API de renderizado de secciones:

    /collections/<handle>?filter...&section_id=asistente-resultados

  Si con todos los criterios no hay ninguno se van quitando en este orden:
  luz, medida, forma. Si la peticion falla se ensena un enlace a la coleccion
  con los mismos filtros, asi que el visitante nunca se queda sin salida.

  El paso y las respuestas viajan en el hash (#a/<paso>/<plazo>/<forma>/
  <medida>/<luz>): el boton Atras del navegador vuelve a la pregunta anterior y
  al volver de una ficha se recupera el resultado.
*/
(function () {
  if (window.customElements.get('asistente-espejo')) return;

  var RELAX_ORDER = ['luz', 'medida', 'forma'];
  var HASH_PREFIX = '#a/';
  var TIMEOUT_MS = 12000;

  class AsistenteEspejo extends HTMLElement {}

  var proto = AsistenteEspejo.prototype;

  proto.connectedCallback = function () {
    if (this.ready) return;
    this.ready = true;

    this.body = this.querySelector('[data-asis-body]');
    this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-asis-step]'));
    this.result = this.querySelector('[data-asis-result]');
    if (!this.body || !this.steps.length || !this.result) return;

    this.keys = this.steps.map(function (step) {
      return step.dataset.asisStep;
    });
    this.total = this.steps.length;
    this.answers = {};
    this.current = 0;
    this.requestId = 0;
    this.cache = {};

    this.progress = this.querySelector('[data-asis-progress]');
    this.status = this.querySelector('[data-asis-status]');
    this.backButton = this.querySelector('[data-asis-back]');
    this.resultTitle = this.querySelector('[data-asis-result-title]');
    this.summary = this.querySelector('[data-asis-summary]');
    this.note = this.querySelector('[data-asis-note]');
    this.loading = this.querySelector('[data-asis-loading]');
    this.list = this.querySelector('[data-asis-list]');
    this.grid = this.querySelector('[data-asis-grid]');
    this.error = this.querySelector('[data-asis-error]');
    this.allLink = this.querySelector('[data-asis-all]');
    this.allLabel = this.querySelector('[data-asis-all-label]');

    this.addEventListener('click', this.onClick.bind(this));
    this.onPopState = this.onPopState.bind(this);
    window.addEventListener('popstate', this.onPopState);

    this.body.hidden = false;

    var saved = this.readHash();
    if (saved) {
      this.answers = saved.answers;
      this.show(saved.step, { focus: false, history: 'none' });
    } else {
      this.show(0, { focus: false, history: 'none' });
    }
  };

  proto.disconnectedCallback = function () {
    window.removeEventListener('popstate', this.onPopState);
  };

  /* ------------------------------------------------------------ eventos --- */

  proto.onClick = function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var option = target.closest('.asis-opt, .asis-skip');
    if (option && this.contains(option)) {
      var step = option.closest('[data-asis-step]');
      if (!step) return;
      this.answers[step.dataset.asisStep] = option.dataset.value || '';
      this.track('respuesta', step.dataset.asisStep, option.dataset.value || 'me-da-igual');
      this.show(this.keys.indexOf(step.dataset.asisStep) + 1, { focus: true, history: 'push' });
      return;
    }

    if (target.closest('[data-asis-back]')) {
      this.back();
      return;
    }

    if (target.closest('[data-asis-restart]')) {
      this.answers = {};
      this.track('reinicio', '', '');
      this.show(0, { focus: true, history: 'push' });
    }
  };

  proto.onPopState = function () {
    var saved = this.readHash();
    // El foco solo se mueve si ya estaba dentro del asistente
    var focus = this.contains(document.activeElement);
    if (saved) {
      // Al retroceder se conservan las respuestas ya dadas: la opcion elegida
      // sigue marcada y basta con pulsar otra para cambiarla
      this.answers = Object.assign({}, this.answers, saved.answers);
      this.show(saved.step, { focus: focus, history: 'none' });
    } else {
      this.show(0, { focus: focus, history: 'none' });
    }
  };

  proto.back = function () {
    if (this.current <= 0) return;
    var state = null;
    try {
      state = window.history.state;
    } catch (e) {}
    // Si la entrada anterior del historial es nuestra, se vuelve con el
    // navegador para no ir dejando pasos repetidos detras.
    if (state && state.asistente && state.previous) {
      window.history.back();
      return;
    }
    this.show(this.current - 1, { focus: true, history: 'replace' });
  };

  /* ------------------------------------------------------------- pasos --- */

  proto.show = function (index, options) {
    options = options || {};
    index = Math.max(0, Math.min(index, this.total));
    this.current = index;
    var isResult = index === this.total;

    this.steps.forEach(function (step, i) {
      step.hidden = i !== index;
    });
    this.result.hidden = !isResult;
    this.classList.toggle('is-result', isResult);
    this.classList.toggle('is-started', index > 0);

    this.markSelected();
    this.updateProgress();
    if (this.backButton) this.backButton.hidden = index === 0;

    this.writeHistory(options.history || 'none');

    var heading = isResult ? this.resultTitle : this.steps[index].querySelector('.asis-q__title');
    if (options.focus) {
      this.reveal();
      if (heading) {
        try {
          heading.focus({ preventScroll: true });
        } catch (e) {
          heading.focus();
        }
      }
    }

    if (isResult) this.loadResults();
  };

  proto.markSelected = function () {
    var answers = this.answers;
    this.steps.forEach(function (step) {
      var key = step.dataset.asisStep;
      var has = Object.prototype.hasOwnProperty.call(answers, key);
      Array.prototype.forEach.call(step.querySelectorAll('.asis-opt, .asis-skip'), function (button) {
        var selected = has && (button.dataset.value || '') === answers[key];
        button.classList.toggle('is-selected', selected);
        if (selected) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    });
  };

  proto.updateProgress = function () {
    var index = this.current;
    var isResult = index === this.total;
    var text = isResult ? 'Resultado' : 'Pregunta ' + (index + 1) + ' de ' + this.total;

    if (this.progress) {
      this.progress.setAttribute('aria-valuenow', String(isResult ? this.total : index + 1));
      this.progress.setAttribute('aria-valuetext', text);
      Array.prototype.forEach.call(this.progress.children, function (bar, i) {
        bar.classList.toggle('is-done', i < index);
        bar.classList.toggle('is-current', i === index);
      });
    }
    if (this.status && this.status.textContent !== text) this.status.textContent = text;
  };

  // Lleva el asistente a la vista si el cambio de pantalla lo ha dejado fuera
  proto.reveal = function () {
    try {
      var rect = this.getBoundingClientRect();
      if (rect.top >= 0 && rect.top < window.innerHeight * 0.4) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    } catch (e) {}
  };

  /* ---------------------------------------------------------- historial --- */

  proto.buildHash = function () {
    var answers = this.answers;
    var parts = this.keys.map(function (key) {
      if (!Object.prototype.hasOwnProperty.call(answers, key)) return '-';
      return answers[key] === '' ? '_' : encodeURIComponent(answers[key]);
    });
    return HASH_PREFIX + this.current + '/' + parts.join('/');
  };

  proto.readHash = function () {
    var hash = window.location.hash || '';
    if (hash.indexOf(HASH_PREFIX) !== 0) return null;
    var parts = hash.slice(HASH_PREFIX.length).split('/');
    var step = parseInt(parts[0], 10);
    if (isNaN(step) || step < 0 || step > this.total) return null;

    var answers = {};
    var self = this;
    this.keys.forEach(function (key, i) {
      var raw = parts[i + 1];
      if (raw === undefined || raw === '-') return;
      var value = raw === '_' ? '' : decodeURIComponent(raw);
      // Solo valen las respuestas que existen como boton
      if (self.findOption(key, value)) answers[key] = value;
    });

    // No se puede estar mas adelante que la primera pregunta sin contestar
    for (var i = 0; i < this.keys.length; i++) {
      if (!Object.prototype.hasOwnProperty.call(answers, this.keys[i])) {
        step = Math.min(step, i);
        break;
      }
    }
    return { step: step, answers: answers };
  };

  proto.writeHistory = function (mode) {
    if (mode === 'none') return;
    try {
      var url = window.location.pathname + window.location.search + (this.current === 0 && !Object.keys(this.answers).length ? '' : this.buildHash());
      if (mode === 'push') {
        var current = window.history.state;
        if (!current || !current.asistente) {
          window.history.replaceState({ asistente: true, previous: false }, '', window.location.href);
        }
        window.history.pushState({ asistente: true, previous: true }, '', url);
      } else {
        var state = window.history.state;
        window.history.replaceState({ asistente: true, previous: !!(state && state.previous) }, '', url);
      }
    } catch (e) {}
  };

  /* ---------------------------------------------------------- criterios --- */

  proto.findOption = function (key, value) {
    var step = this.steps[this.keys.indexOf(key)];
    if (!step) return null;
    var buttons = step.querySelectorAll('.asis-opt, .asis-skip');
    for (var i = 0; i < buttons.length; i++) {
      if ((buttons[i].dataset.value || '') === value) return buttons[i];
    }
    return null;
  };

  proto.selectedOption = function (key) {
    if (!Object.prototype.hasOwnProperty.call(this.answers, key)) return null;
    return this.findOption(key, this.answers[key]);
  };

  proto.collectionUrl = function () {
    var option = this.selectedOption('plazo');
    return (option && option.dataset.url) || this.dataset.urlDefault || '/collections/all';
  };

  // Parametros de filtro de las respuestas, sin las claves que se relajan
  proto.buildParams = function (dropped) {
    var params = new URLSearchParams();
    var self = this;
    this.keys.forEach(function (key) {
      if (dropped.indexOf(key) !== -1) return;
      var option = self.selectedOption(key);
      if (!option || !option.dataset.param || !option.dataset.filter) return;
      option.dataset.filter.split('|').forEach(function (value) {
        params.append(option.dataset.param, value);
      });
    });
    return params;
  };

  // Intentos en orden: todo; sin luz; sin luz ni medida; sin luz, medida ni forma
  proto.buildAttempts = function () {
    var self = this;
    var attempts = [[]];
    var dropped = [];
    RELAX_ORDER.forEach(function (key) {
      var option = self.selectedOption(key);
      if (!option || !option.dataset.param) return;
      dropped = dropped.concat(key);
      attempts.push(dropped);
    });
    return attempts;
  };

  proto.buildSummary = function () {
    var forma = this.selectedOption('forma');
    var luz = this.selectedOption('luz');
    var medida = this.selectedOption('medida');
    var plazo = this.selectedOption('plazo');

    var head = [];
    if (forma && forma.dataset.resumen) head.push(forma.dataset.resumen);
    if (luz && luz.dataset.resumen) head.push(luz.dataset.resumen);

    var tail = [];
    if (medida && medida.dataset.resumen) tail.push(medida.dataset.resumen);
    if (plazo && plazo.dataset.resumen) tail.push(plazo.dataset.resumen);

    if (!head.length && !tail.length) {
      return 'No has puesto ninguna condición, así que aquí tienes tres para empezar.';
    }
    var text = 'Buscas un espejo';
    if (head.length) text += ' ' + head.join(' ');
    if (tail.length) text += (head.length ? ', ' : ' ') + tail.join(', ');
    return text + '.';
  };

  proto.joinLabels = function (keys) {
    var steps = this.steps;
    var all = this.keys;
    var labels = keys.map(function (key) {
      var step = steps[all.indexOf(key)];
      return (step && step.dataset.asisLabel) || key;
    });
    if (labels.length <= 1) return labels.join('');
    return labels.slice(0, -1).join(', ') + ' y ' + labels[labels.length - 1];
  };

  /* --------------------------------------------------------- resultados --- */

  // Un segundo intento si el primero falla (un corte suelto de red o del servidor)
  proto.fetchAttempt = function (base, params) {
    var self = this;
    return this.fetchOnce(base, params).catch(function () {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, 900);
      }).then(function () {
        return self.fetchOnce(base, params);
      });
    });
  };

  proto.fetchOnce = function (base, params) {
    var query = params.toString();
    var pageUrl = base + (query ? '?' + query : '');
    if (this.cache[pageUrl]) return Promise.resolve(this.cache[pageUrl]);

    var sectionParams = new URLSearchParams(query);
    sectionParams.set('section_id', this.dataset.resultsSection || 'asistente-resultados');

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller
      ? window.setTimeout(function () {
          controller.abort();
        }, TIMEOUT_MS)
      : null;
    var cache = this.cache;

    return window
      .fetch(base + '?' + sectionParams.toString(), {
        credentials: 'same-origin',
        signal: controller ? controller.signal : undefined,
      })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (timer) window.clearTimeout(timer);
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-asis-results]');
        if (!node) throw new Error('Respuesta sin resultados');
        var cards = node.querySelectorAll('.f-column').length;
        var count = parseInt(node.getAttribute('data-count'), 10) || 0;
        var data = {
          pageUrl: pageUrl,
          count: cards ? Math.max(count, cards) : 0,
          cards: cards,
          html: cards ? node.innerHTML : '',
        };
        cache[pageUrl] = data;
        return data;
      })
      .catch(function (error) {
        if (timer) window.clearTimeout(timer);
        throw error;
      });
  };

  proto.loadResults = function () {
    var self = this;
    var requestId = ++this.requestId;
    var base = this.collectionUrl();
    var attempts = this.buildAttempts();
    var fallbackUrl = base;
    var firstQuery = this.buildParams([]).toString();
    if (firstQuery) fallbackUrl += '?' + firstQuery;

    this.setResultState('loading');
    this.resultTitle.textContent = 'Buscando tus espejos…';
    this.summary.textContent = this.buildSummary();
    this.note.hidden = true;
    this.allLink.hidden = true;

    function attempt(i) {
      var dropped = attempts[i];
      return self.fetchAttempt(base, self.buildParams(dropped)).then(function (data) {
        if (data.cards > 0 || i === attempts.length - 1) return { data: data, dropped: dropped };
        return attempt(i + 1);
      });
    }

    attempt(0)
      .then(function (found) {
        if (requestId !== self.requestId) return;
        self.renderResults(found.data, found.dropped);
      })
      .catch(function () {
        if (requestId !== self.requestId) return;
        self.renderError(fallbackUrl);
      });
  };

  proto.setResultState = function (state) {
    this.result.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    this.loading.hidden = state !== 'loading';
    this.list.hidden = state !== 'ready';
    this.error.hidden = state !== 'error';
  };

  proto.renderResults = function (data, dropped) {
    if (!data.cards) {
      // Ni la coleccion sin filtros tiene nada: se ofrece el catalogo entero
      this.renderError(this.dataset.urlDefault || data.pageUrl);
      return;
    }

    this.grid.innerHTML = data.html;
    this.grid.setAttribute('data-count', String(data.cards));

    var relaxed = dropped.length > 0;
    var titles = { 1: 'Este es el que encaja contigo', 2: 'Estos dos encajan contigo', 3: 'Estos tres encajan contigo' };
    this.resultTitle.textContent = relaxed
      ? 'No hay ninguno con todo; estos son los más parecidos'
      : titles[data.cards] || titles[3];

    if (relaxed) {
      this.note.textContent = 'Para encontrarlos hemos dejado fuera ' + this.joinLabels(dropped) + '.';
      this.note.hidden = false;
    } else {
      this.note.hidden = true;
    }

    this.allLink.href = data.pageUrl;
    this.allLabel.textContent =
      (relaxed ? 'Ver todos los parecidos' : 'Ver todos los que encajan') + (data.count > data.cards ? ' (' + data.count + ')' : '');
    this.allLink.hidden = false;

    this.setResultState('ready');
    this.track('resultado', relaxed ? 'relajado' : 'exacto', String(data.count));
  };

  proto.renderError = function (url) {
    this.resultTitle.textContent = 'Tus espejos te esperan en la tienda';
    this.note.hidden = true;
    this.allLink.href = url;
    this.allLabel.textContent = 'Ver los espejos que encajan';
    this.allLink.hidden = false;
    this.setResultState('error');
    this.track('resultado', 'error', '');
  };

  /* ------------------------------------------------------------- medida --- */

  proto.track = function (accion, paso, valor) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'asistente_espejo',
        asistente_accion: accion,
        asistente_paso: paso,
        asistente_valor: valor,
      });
    } catch (e) {}
  };

  window.customElements.define('asistente-espejo', AsistenteEspejo);
})();
